export default {"src":"/_next/static/media/course-evaluate.0a7b0e38.svg","height":28,"width":28};